import { render } from "./GoPlayView.vue?vue&type=template&id=40774099&scoped=true"
import script from "./GoPlayView.vue?vue&type=script&lang=js"
export * from "./GoPlayView.vue?vue&type=script&lang=js"

import "./GoPlayView.vue?vue&type=style&index=0&id=40774099&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40774099"]])

export default __exports__